import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import ConsentModal from '../ConsentModal/ConsentModal'

import MasterCard from '../../../assets/img/card-linking/mastercard.svg'
import VisaCard from '../../../assets/img/card-linking/visacard.svg'

const StyledIFrame = styled.iframe.attrs({ seamless: true })`
  width: 100%;
  height: 300px;
  border: 0;
`

const Status = styled.p`
  padding: 0.59375rem 1rem;
  position: relative;
  margin-top: 0;
  margin-bottom: 0.625rem;
  font-size: 0.875rem;
  transition-property: padding, margin;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);
  overflow: hidden;

  &::before {
    content: ' ';
    display: block;
    border-radius: var(--border-radius-form);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--color-error);
    opacity: 0.1;
  }

  &:empty {
    padding-top: 0;
    padding-bottom: 0;
    margin: 0;
  }
`

const CardImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  margin-bottom: 40px;
`

const CardImage = styled.img`
  margin: 8px;
`

const Terms = styled.div`
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 1.3125rem;
  margin: 2rem 0;
  text-align: center;
`

const StyledConsentModal = styled(ConsentModal)`
  color: var(--color-primary);
`

function AddCardForm(props) {
  const { apiKey, programCode, onLoad, addCardError, onConsentClick } = props

  const addCardBaseUrl = process.env.REACT_APP_OPENSPARKZ_BASE_URL
  const addCardUrl = `${addCardBaseUrl}?key=${apiKey}&programCode=${programCode}`

  return (
    <>
      <Status>{addCardError}</Status>
      {!!apiKey && (
        <StyledIFrame onLoad={onLoad} title="Add Card Form" src={addCardUrl} />
      )}
      <CardImageWrapper>
        <CardImage src={MasterCard} height={32} />
        <CardImage src={VisaCard} height={20} />
      </CardImageWrapper>
      <Terms>
        By adding and linking your credit card, you agree to the program{' '}
        <StyledConsentModal zIndex={10022} onClick={onConsentClick}>
          Cardholder Consent & Transaction Monitoring
        </StyledConsentModal>
      </Terms>
    </>
  )
}

AddCardForm.defaultProps = {
  apiKey: null,
}

AddCardForm.propTypes = {
  apiKey: PropTypes.string,
}

export default AddCardForm
